import * as React from 'react';
import { ReactNode } from 'react';

interface IMainTemplateProps {
    tableArea: ReactNode
    modalActions: ReactNode
}

const UnderwritingTemplate: React.FunctionComponent<IMainTemplateProps> = ({ tableArea, modalActions }) => {
    return (
        <div style={{
            marginBottom: 100,
            display: 'flex',
            flexDirection:'column',
            flex: 1,
            // justifyContent: 'center',
            // alignItems: 'center'
        }}>
            {tableArea}
            < div style={{ position: 'fixed', bottom: 24, right: 24 }}>
                {modalActions}
            </div >

        </div >

    );
};

export default UnderwritingTemplate;
